import { useState } from "react";
import { useTranslation } from "react-i18next";
import { currValidationFieldName } from "../../../../../utils/API";
import { TrashBin } from "../../../../Icons";
import ActionButton from "../../../CycleManager/Checklist/ChecklistTable/ActionButton";
import { UpdateType } from "../../EditorContextProvider";
import { EditType } from "../../EditorSwiper/EditorSwiper";
import Message from "../../Message";

const DeleteButton = ({
  editType,
  updateType,
  editableLayer,
  getIsDeletedField,
  activeColor,
  count,
  isActive,
  doDelete,
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showDeleteReport, setShowDeleteReport] = useState(false);
  const { t } = useTranslation("common");

  return (
    <>
      {showDelete && (
        <Message
          title={t("screen.widget.Editor.deleteConfirmation")}
          onSubmit={() => {
            doDelete();
            setShowDeleteReport(false);
            setShowDelete(false);
          }}
          onCancel={() => {
            setShowDeleteReport(false);
            setShowDelete(false);
          }}
          color={activeColor}
        />
      )}
      {showDeleteReport && (
        <Message
          title={t("screen.widget.Editor.manager.reports.deleteMessage.title")}
          submitTitle="Not valid"
          cancelTitle="Expired outdated"
          onSubmit={() => {
            doDelete({
              [currValidationFieldName]: 6,
            });
            setShowDeleteReport(false);
          }}
          onCancel={() => {
            doDelete({
              [currValidationFieldName]: 10,
            });
            setShowDeleteReport(false);
          }}
          color={activeColor}
          btnDirPosition="column"
          additionalBtnTitle={t(
            "screen.widget.Editor.manager.reports.deleteMessage.cancel"
          )}
          onAdditionBtnClick={() => setShowDeleteReport(false)}
        />
      )}
      {editType === EditType.edit &&
      (updateType === UpdateType.baseline ||
        (editableLayer?.layerConfig &&
          editableLayer?.layerConfig?.allowDeleteWhenSituational)) &&
      getIsDeletedField() ? (
        <ActionButton
          Icon={TrashBin}
          color={activeColor}
          onClick={() => {
            editableLayer?.layerConfig?.isShownInReportManager
              ? setShowDeleteReport(true)
              : setShowDelete(true);
          }}
          count={count}
          isActive={isActive}
          styles={{
            padding: "0px 8px",
          }}
        />
      ) : null}
    </>
  );
};

export default DeleteButton;
